/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';

type Props = {
  id: string;
  src: string;
  isPaused?: boolean;
  className?: string;
};

function NimioPlayer({ src, id }: Readonly<Props>) {
  const containerRef = useRef<HTMLDivElement>(null);
  const nimioInstanceRef = useRef<any>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    if (!('Nimio' in window)) {
      console.error('Nimio not loaded');
      return;
    }
    const Nimio: any = window.Nimio;

    if (container.clientWidth === 0 || container.clientHeight === 0) {
      console.warn('Nimio container has zero size at mount', id);
    }

    let instance: any;
    try {
      instance = new Nimio({
        streamUrl: src,
        container,
        autoplay: true,
        muted: true,
        videoOnly: true,
        metricsOverlay: false,
        logLevel: 'debug',
        startOffset: 10000,
      });
      nimioInstanceRef.current = instance;
    } catch (e) {
      console.error('Error initializing Nimio:', e);
    }

    return () => {
      try {
        instance?.destroy?.();
      } catch {
        /* empty */
      }
      if (nimioInstanceRef.current === instance) {
        nimioInstanceRef.current = null;
      }
    };
  }, [id, src]);

  return <Box ref={containerRef} id={id} width="100%" height="100%" className="nimio-container" />;
}

export default NimioPlayer;
